import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'

export const COMPANY_IGNORE_ALLOWED_ROLES = [ROLE_PLATFORM_HIXME_ADMIN]

export function canUseCompanyIgnore(role?: string | null): boolean {
  return COMPANY_IGNORE_ALLOWED_ROLES.includes(role ?? '')
}
